module.exports = __webpack_public_path__ + "static/media/photo68.bfe1b8a6.jpg";